import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  GET_PATIENT_TIME_SLOTS_REQUEST,
  GET_PATIENT_TIME_SLOTS_SUCCESS,
  GET_PATIENT_TIME_SLOTS_FAILURE,
} = TherapistAction;

function* getPatientTimeSlots(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.getPatientTimeSlots,
      action.payload
    );
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_TIME_SLOTS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_TIME_SLOTS_FAILURE, payload: error });
  }
}

function* getPatientTimeSlotsSaga() {
  yield takeEvery(GET_PATIENT_TIME_SLOTS_REQUEST, getPatientTimeSlots);
}

export default getPatientTimeSlotsSaga;

